import debounce from 'lodash/debounce';
import { fillParentContainer } from 'fancy-textfill';

$(document).ready(handleDynamicSizes);

$(window).on('resize', debounce(handleDynamicSizes, 100));

function handleDynamicSizes() {
  const content = document.querySelector('.js-toolbox-text');

  if (content !== null) {
    fillParentContainer(content, {
      maxFontSize: 67,
      maxHeight: $(content).height(),
    });
  }
}